<script setup lang="ts">
    import { ref, defineProps, defineEmits, onMounted } from 'vue';
    import axios from 'axios';

    const props = defineProps({ accessToken: { type: String, required: true } });
    const emit = defineEmits(['otpRegistered']);

    const errorMessage = ref('');
    const loading = ref(false);
    const mfa_qr_code = ref(null);
    const mfa_security_key = ref(null);

    onMounted(() => {
        doGetMfaQrCodeAction();
    });

    async function doGetMfaQrCodeAction() {
        loading.value = true;
        errorMessage.value = '';
        try {
            const httpResponse = await axios.get(`/backoffice/auth/get_mfa_qr_code`, { headers: { Authorization: `Bearer ${props.accessToken}` } });
            mfa_qr_code.value = httpResponse.data.mfa_qr_code;
            mfa_security_key.value = httpResponse.data.mfa_security_key;
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }
    }

    async function doEnableMfaAction() {
        loading.value = true;
        errorMessage.value = '';
        try {
            await axios.post(`/backoffice/auth/enable_mfa`, {}, { headers: { Authorization: `Bearer ${props.accessToken}` } });
            emit('otpRegistered');
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }
    }

</script>

<template>
    <div>
        <h1 class="font-semibold my-8 text-center">Vérification OTP <span class="text-sm text-grey-500"></span></h1>
        <div class="text-center">Activer la double authentification en scannant le QR Code ci-dessous ou en saisissant le code de sécurité dans votre application Authenticator</div>
        <div>
            <div class="my-5">
                <div class="text-center">QR Code</div>
                <div style="text-align: center;">
                    <div v-if="mfa_qr_code" style="display: inline-block; border: 1px solid #ddd; padding: 10px; background: white;">
                        <!-- Détecter si c'est du SVG (base64 commence par PHN2Zw) ou une image PNG -->
                        <img v-if="!mfa_qr_code.startsWith('PHN2Zw')" :src="'data:image/png;base64,' + mfa_qr_code" height="200px" alt="QR Code MFA" />
                        <img v-else :src="'data:image/svg+xml;base64,' + mfa_qr_code" height="200px" alt="QR Code MFA" />
                    </div>
                    <div v-else-if="loading" class="text-center">
                        <p>Génération du QR code...</p>
                    </div>
                    <div v-else class="text-red text-center">
                        <p>Erreur lors de la génération du QR code. Veuillez utiliser la clé de sécurité ci-dessous.</p>
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="text-center">Clé de sécurité</div>
                <div style="text-align: center;">
                    <h6 class="font-semibold text-center">{{ mfa_security_key }}</h6>
                </div>
            </div>

            <div class="mt-7">
                <div v-if="!!errorMessage" class="text-red text-center mb-5">{{ errorMessage }}</div>
                <div class="flex">
                    <custom-button id="btn-submit" type="submit" :classesList="'btn xl s20'" :loading="loading" @click="doEnableMfaAction" v-if="mfa_qr_code">
                        <img src="/icons/icon-menu-securite.svg" class="btn-icon" alt="" />
                        <span>Activer la double authentification</span>
                    </custom-button>
                </div>
            </div>
        </div>
    </div>
</template>
